/* global HelpCrunch */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  bindSessions,
  unbind,
  createSession,
  updateSession,
  buySession,
  resetAddEditClassForm
} from 'actions/sessionActions';
import { completeRegistration } from 'actions/authActions';
import { updateProfile } from "actions/profileActions";
import SessionList from './sessionList';
import AddEditClassModal from './addEditClassModal';
import CompleteRegistrationModal from './completeRegistrationModal';
import characterImage from '../../images/esmeralda_goober_half_wave.png';
import './homeDashboard.scss';
import featureFlags from "../../featureFlags";
import {parseCookie} from "services/cookie";
import * as programs from 'services/programs'

class HomeDashboard extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      authData: PropTypes.shape({
        uid: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    sessions: PropTypes.object.isRequired,
    bindSessions: PropTypes.func.isRequired,
    unbind: PropTypes.func.isRequired,
    createSession: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    buySession: PropTypes.func.isRequired,
    resetAddEditClassForm: PropTypes.func.isRequired,
    completeRegistration: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    updateProfile: PropTypes.func.isRequired
  };

  static contextTypes = {
    staff: PropTypes.bool,
    location: PropTypes.object.isRequired,
    userId: PropTypes.string
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      showAddEditClassModal: false,
      showCompleteRegistrationModal: false,
      loading: true,
      availablePrograms: [],
      editSession: null
    };
  }

  componentDidMount () {
    const userId = this.props.auth.authData.uid;
    this.boundRefs = [];
    this.props.bindSessions(userId, this.boundRefs);
    this.count = 0;
    this.interval = setInterval(() => {
      if (this.count === this.props.sessions.sessionList.length) {
        clearInterval(this.interval);
        this.setState({loading: false});
      }
      this.count = this.props.sessions.sessionList.length;
    }, 250);
    dataLayer.push({ event: 'showChatWidget' });
  }

  componentWillUnmount () {
    this.props.unbind(this.boundRefs);
    clearInterval(this.interval);
  }

  componentWillReceiveProps(nextProps) {
    const hasCompletedRegistration = !!nextProps.profile.school;
    const nbSessions = nextProps.sessions.sessionList.length;
    const featuredProgram = programs.getFeaturedProgramHelper();
    this.setState({
      showCompleteRegistrationModal: !hasCompletedRegistration
    });
    if (featureFlags.autoCreateClassWhenFeaturedProgramIsPresent) {
      if (hasCompletedRegistration && !featuredProgram.found && nextProps.sessions.empty) {
        this.openAddEditClassModal(nextProps.profile);
      }
      const firstSessionId = nextProps.sessions.sessionList[0];
      const firstSession = firstSessionId ? nextProps.sessions.sessions[firstSessionId] : {};
      if (hasCompletedRegistration && featuredProgram.found && nbSessions === 1 && firstSession.auto) {
        this.openAddEditClassModal(nextProps.profile, "Class details", "Almost there! We just need the last few details about your class.", firstSessionId);
      }
    }
  }

  openAddEditClassModal(useProfile, title, text, editSession) {
    const profile = useProfile || this.props.profile;
    const featuredPrograms = programs.getFeaturedProgramsForProfile(profile);
    if (featuredPrograms.length > 0) {
      const featuredProgram = programs.getFeaturedProgramHelper(featuredPrograms[0].id)
      this.props.resetAddEditClassForm({
        program: featuredProgram.programId,
        language: featuredProgram.featuredLanguage
      });
    } else {
      this.props.resetAddEditClassForm();
    }
    const availablePrograms = featuredPrograms.length > 0 ? featuredPrograms : programs.getAvailableProgramsForProfile(profile);
    this.setState({ showAddEditClassModal: true, addEditClassTitle: title, addEditClassText: text, editSession, availablePrograms });
  }

  closeAddEditClassModal() {
    this.setState({ showAddEditClassModal: false });
  }

  updateSession(data) {
    const { program: programId, language, grade, divisionName, numberOfStudents } = data;
    const userId = this.context.userId;
    this.props.updateSession(this.state.editSession, programId, {
      language,
      grade,
      divisionName,
      numberOfStudents: parseInt(numberOfStudents, 10),
      auto: false
    }, userId);
    this.closeAddEditClassModal();
  }

  createSession(data) {
    const userId = this.props.auth.authData.uid;
    const { sessions } = this.props;
    const { staff } = this.context;
    const contractId = tryGetCookieValue("contractId");
    const { program: programId, language, grade, divisionName, numberOfStudents } = data;
    const { referrerUserId } = (parseCookie(tryGetCookieValue('ppa_referral')) || this.props.profile);
    const hasFeaturedPrograms = programs.hasFeaturedPrograms();
    return this.props.createSession(userId, programId, {
      language,
      grade,
      divisionName,
      numberOfStudents: parseInt(numberOfStudents, 10),
      pendingApproval: !(staff || (hasFeaturedPrograms && contractId)),
      firstClass: sessions.sessionList && sessions.sessionList.length === 0,
      contractId: hasFeaturedPrograms && contractId,
      referrerUserId
    }).then(() => {
      if (this.props.profile.gettingStartedOptIn) return;
      return this.props.updateProfile(userId, {...this.props.profile, gettingStartedOptIn: true, consent: 'implicit'});
    }).then(() => {
      this.closeAddEditClassModal();
    });
  }

  _sessionClassIndexList() {
    const fundedIndexList = [];
    const notFundedIndexList = [];
    const { sessions } = this.props;
    const { sessionList: sessionIdList } = sessions;
    const activeSessionList = sessionIdList.map(id => {
      return {id, ...sessions.sessions[id]};
    }).filter(session => !session.archived);
    activeSessionList.sort((left, right) => right.updatedAt - left.updatedAt);
    activeSessionList.map((session, index) => {
      const { staff } = this.context;
      if (staff) fundedIndexList.push(index);
      if (session.funding === 'STRIPE' || session.funding === 'CONTRACT') {
        const validUntilDate = new Date(session.validUntil);
        if (Date.now() < validUntilDate) fundedIndexList.push(index);
      } else if (!session.pendingApproval && !session.hiddenAt) {
        fundedIndexList.push(index);
      } else {
        notFundedIndexList.push(index);
      }
    });
    return {fundedIndexList, notFundedIndexList};
  }

  closeCompleteRegistrationModal() {
    this.setState({showCompleteRegistrationModal: false});
  }

  submitCompleteRegistration(data) {
    const userId = this.props.auth.authData.uid;
    this.props.completeRegistration(userId, this.props.profile, data)
      .then(() => this.setState({showCompleteRegistrationModal: false}));
  }

  render () {
    const {
      showAddEditClassModal, showCompleteRegistrationModal,
      addEditClassText, addEditClassTitle
    } = this.state;
    const {sessions} = this.props;
    const {sessionList, empty} = sessions;
    const {loading, availablePrograms, editSession} = this.state;
    const noSessions = sessionList.filter(sessionId => {
      const session = sessions.sessions[sessionId];
      return !session.archived;
    }).length === 0;
    const programLookup = programs.getProgramsLookup();
    if (empty) {
      return (
          <div className="register-success">
            <CompleteRegistrationModal showModal={showCompleteRegistrationModal}
                                       closeModal={::this.closeCompleteRegistrationModal}
                                       onSubmit={::this.submitCompleteRegistration} />
            <div className="row">
              <div className="col-md-5">
                <img className="character-image" src={characterImage}/>
              </div>
              <div className="welcomeHeaderContainer col-md-7">
                <h4 className="welcomeHeader" id="welcomeHeader1">Welcome to the Planet Protector Academy!</h4>
                <h4 className="welcomeHeader" id="welcomeHeader2">Almost there! Just add your class to begin!
                  to?</h4>
                <button
                    className="welcomeHeaderBtn btn btn-primary btn-sm glyphicon glyphicon-plus"
                    onClick={() => this.openAddEditClassModal()}>
                  Add my first class
                </button>
                <AddEditClassModal
                    programs={availablePrograms}
                    showModal={showAddEditClassModal}
                    text={addEditClassText}
                    title={addEditClassTitle}
                    edit={false}
                    onSubmit={::this.createSession}
                    closeModal={::this.closeAddEditClassModal}/>
              </div>
            </div>
          </div>
      );
    }

    return (
      <div>
        <CompleteRegistrationModal showModal={showCompleteRegistrationModal}
                                   closeModal={::this.closeCompleteRegistrationModal}
                                   onSubmit={::this.submitCompleteRegistration} />
        {loading &&
        <div>
          <h3>Loading...</h3>
        </div>
        }
        <SessionList
            sessions={sessions}
            programLookup={programLookup}
            resetAddEditClassForm={this.props.resetAddEditClassForm}
            updateSession={this.props.updateSession}
            buySession={this.props.buySession}
            filterIfFunded />
        {!loading && noSessions &&
        <div>
          <h3>All your classes are archived, please add a new one.</h3>
        </div>
        }
        <AddEditClassModal
          programs={availablePrograms}
          showModal={showAddEditClassModal}
          text={addEditClassText}
          title={addEditClassTitle}
          edit={!!editSession}
          onSubmit={editSession
            ? ::this.updateSession
            : ::this.createSession}
          closeModal={::this.closeAddEditClassModal}/>
      </div>
    );
  }
}

export default connect(
  state => ({
    auth: state.auth,
    profile: state.profile,
    sessions: state.sessions
  }),
  {
    bindSessions,
    unbind,
    createSession,
    updateSession,
    buySession,
    resetAddEditClassForm,
    completeRegistration,
    updateProfile
  }
)(HomeDashboard);



// WEBPACK FOOTER //
// ./src/views/dashboard/homeDashboard.jsx